import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { Designation } from '../types/userTypes';

// Async thunk for fetching only designations
export const fetchDesignations = createAsyncThunk(
  'users/fetchDesignations',
  async (_, { rejectWithValue }) => {
    try {
      console.log('Fetching designations directly...');

      // Look for either admin or employee token in cookies
      const cookies = document.cookie.split('; ');
      let token = cookies.find(row => row.startsWith('pms_admin_='))?.split('=')[1];

      // If no admin token found, check for employee token
      if (!token) {
        token = cookies.find(row => row.startsWith('pms_employee_='))?.split('=')[1];
      }

      if (!token) {
        console.error('No authentication token found in cookies');
        return rejectWithValue('Authentication token is missing');
      }

      // Make the API request with the token in the headers
      const response = await axios.get('/api/v1/list/users', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.data.success) {
        // Only extract and return the designations from the response
        const designations: Designation[] = response.data.data.designations || [];
        console.log('Fetched designations:', designations);
        return designations;
      } else {
        console.error('API returned failure:', response.data);
        return rejectWithValue(response.data.message || 'Failed to fetch designations');
      }
    } catch (error: any) {
      console.error('Error fetching designations:', error);
      return rejectWithValue(
        error.response?.data?.message || error.message || 'An error occurred while fetching designations'
      );
    }
  }
);
